import * as React from 'react';
import useRouter from './useRouter';
import { createLocation } from 'history';

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

var useRouterLink = function useRouterLink(props) {
  var target = props.target,
      to = props.to,
      onClick = props.onClick,
      replace = props.replace;

  var _useRouter = useRouter(),
      history = _useRouter.history,
      contextLocation = _useRouter.location;

  var handleClick = React.useCallback(function (event) {
    try {
      if (onClick) {
        onClick(event);
      }
    } catch (error) {
      event.preventDefault();
      throw error;
    }

    if (!event.defaultPrevented && event.button === 0 && (!target || target === '_self') && !isModifiedEvent(event)) {
        event.preventDefault();

        if (to) {
          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
      }
  }, [onClick, replace, history, target, to]);
  var location = typeof to === 'string' ? createLocation(to, null, null, contextLocation) : to;
  var href = location ? history.createHref(location) : undefined;
  return {
    handleClick: handleClick,
    href: href
  };
};

export default useRouterLink;